import type { ReactNode } from "react";
import { MemberBottomNavigation } from "../member/MemberMobileUi";
import { Button } from "@carepass/ui";
import type { PublicTerm } from "./types";

export function MemberActionBar({ children, secondary }: { readonly children: ReactNode; readonly secondary?: ReactNode }) {
  return <div className={`member-action-bar${secondary ? " member-action-bar--split" : ""}`}>{secondary}{children}</div>;
}

export function LegalDocument({ term, showAgreementRequirement = true }: { readonly term: PublicTerm; readonly showAgreementRequirement?: boolean }) {
  return (
    <article className="legal-document">
      <header>
        <span>{showAgreementRequirement ? `${term.required ? "필수" : "선택"} 약관` : "약관 및 정책"} · {term.versionNo}</span>
        <h1>{term.title}</h1>
        <p>시행일 {term.effectiveFrom.slice(0, 10)}</p>
      </header>
      <div className="legal-document__body">{term.content}</div>
    </article>
  );
}

export function FullWidthPrimary({ children, ...props }: React.ComponentProps<typeof Button>) {
  return <Button size="large" {...props}>{children}</Button>;
}

/** App and route stories deliberately use the same viewport, header and navigation boundary. */
export function MemberScreenFrame({ children, pathname }: { readonly children: ReactNode; readonly pathname: string }) {
 const root = ["/app", "/app/transactions", "/app/benefits", "/app/my"].includes(pathname);
 return <div className="app-shell app-shell--member"><a className="skip-link" href="#main-content">본문으로 바로가기</a><main className="member-content" id="main-content">{children}</main>{root && <MemberBottomNavigation pathname={pathname}/>}</div>;
}
